import React from "react";
import { Typography, Box, Stack } from "@mui/joy";

const stats = [
  {
    value: "10,000+",
    title: "Bills introduced annually",
    description: "Congress introduces over 10,000 bills each year. Most never become law — knowing which ones matter is half the battle.",
  },
  {
    value: "20%",
    title: "Email influence on votes",
    description: "Constituent email campaigns show up to 20% influence on legislative voting behavior. Your message lands.",
  },
  {
    value: "1 in 3",
    title: "Know their representative",
    description: "Only 1 in 3 Americans can name their congressional representative. You can't hold someone accountable you don't know.",
  },
  {
    value: "10%",
    title: "Congress approval rating",
    description: "Only 10% of Americans approve of how Congress is handling its job. Direct contact is how that number changes.",
  },
];

const Stats = () => {
  return (
    <Box
      sx={{
        maxWidth: "1200px",
        mx: "auto",
        width: "100%",
        px: { xs: "1.25rem", md: "2rem" },
        pt: { xs: "3rem", md: "2rem" },
        pb: { xs: "4rem", md: "6rem" },
      }}
    >
      <Stack spacing={1} sx={{ mb: { xs: "3rem", md: "4rem" } }}>
        <Typography
          component="p"
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            color: "var(--ce-dark-eyebrow)",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          }}
        >
          The numbers
        </Typography>
        <Typography
          level="h2"
          sx={{
            color: "white",
            fontSize: { xs: "2rem", md: "3rem" },
            fontWeight: 700,
            lineHeight: 1.2,
          }}
        >
          Empowerment through information
        </Typography>
      </Stack>

      <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 0, md: 0 }}>
        {stats.map((stat, index) => (
          <Box
            key={index}
            sx={{
              flex: 1,
              pl: { md: index > 0 ? "2rem" : 0 },
              pr: { md: index < stats.length - 1 ? "2rem" : 0 },
              borderRight: {
                md: index < stats.length - 1 ? "1px solid rgba(255,255,255,0.12)" : "none",
              },
              borderBottom: {
                xs: index < stats.length - 1 ? "1px solid rgba(255,255,255,0.12)" : "none",
                md: "none",
              },
              pb: { xs: index < stats.length - 1 ? "2.5rem" : 0, md: 0 },
              pt: { xs: index > 0 ? "2.5rem" : 0, md: 0 },
            }}
          >
            <Typography
              component="p"
              sx={{
                fontSize: "64px",
                fontWeight: 700,
                lineHeight: 1,
                color: "var(--ce-dark-secondary)",
                mb: "1rem",
              }}
              role="text"
              aria-label={`${stat.value} — ${stat.title}`}
            >
              {stat.value}
            </Typography>

            <Box
              sx={{
                width: "48px",
                height: "1px",
                backgroundColor: "rgba(255,255,255,0.3)",
                mb: "1rem",
              }}
            />

            <Typography
              sx={{
                color: "white",
                fontWeight: 600,
                fontSize: "1.5rem",
                lineHeight: 1.25,
                mb: "1rem",
              }}
            >
              {stat.title}
            </Typography>

            <Typography
              sx={{
                color: "white",
                lineHeight: 1.65,
                fontSize: "1.125rem",
              }}
            >
              {stat.description}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default Stats;
